const canvasToBlob = (canvas, type, quality) => {
  try {
    canvas.getContext("2d").getImageData(0, 0, 1, 1);
  } catch (err) {
    if (err.code === 18) {
      return Promise.reject(new Error("Cannot read image"));
    }
  }

  return new Promise((resolve) => {
    canvas.toBlob(resolve, type, quality);
  }).then((blob) => {
    if (blob === null) {
      throw new Error("Cannot read image");
    }
    return blob;
  });
};

const getVideoProportionalDimensions = (video, targetWidth, targetHeight) => {
  const aspect = video.videoWidth / video.videoHeight;
  let width = targetWidth;
  let height = Math.round(width / aspect);

  if (height > targetHeight) {
    height = targetHeight;
    width = Math.round(height * aspect);
  }

  return {
    width,
    height,
  };
};

export const createVideoThumbnail = (
  url,
  time,
  targetWidth,
  targetHeight,
  mimeType = "image/jpeg"
) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.setAttribute("controls", true);
    video.setAttribute("muted", "");
    video.setAttribute("preload", "metadata");
    video.setAttribute("crossorigin", "*");
    video.setAttribute("src", url);
    video.addEventListener("loadedmetadata", () => {
      video.currentTime = time;
    });
    video.addEventListener("timeupdate", () => {
      resolve(video);
    });
    video.addEventListener("error", (event) => {
      reject(event.error || new Error("Could not create thumbnail"));
    });
  })
    .then((video) => {
      const dimensions = getVideoProportionalDimensions(
        video,
        targetWidth,
        targetHeight
      );

      video.width = dimensions.width;
      video.height = dimensions.height;

      const canvas = document.createElement("canvas");
      canvas.width = dimensions.width;
      canvas.height = dimensions.height;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);

      return canvasToBlob(canvas, mimeType, 80);
    })
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = (event) => {
            reject(event.error || new Error("Could not create thumbnail"));
          };
          reader.readAsDataURL(blob);
        })
    );
};
